<nav class="menu">
  <ul>
    <li class="user-details show-mob-block">
      @if (userSummary?.profile_image) {
        <span
          class="profile-img"
                [ngStyle]="{
                    'background-image':
                        'url(' + userSummary?.profile_image + ')'
                }"
        ></span>
      }
      @if (!userSummary?.profile_image) {
        <span
          class="profile-img"
                [ngStyle]="{
                    'background-image': 'url(assets/images/empty_profile.png)'
                }"
        ></span>
      }
      <p class="user-name">
        {{ userSummary?.first_name }}
        {{ userSummary?.last_name | slice : 0 : 1 }}.
      </p>
      @if (userSummary?.total_points) {
        <p>
          {{ userSummary?.total_points | number }} Points
        </p>
      }
    </li>
    <li class="menu-item" [ngClass]="{ selected: isCollapsed.dashboard }">
      <a
        id="nav-menu-dashboard-link"
                (click)="
                    $event.stopPropagation();
                    isCollapsed.dashboard = !isCollapsed.dashboard
                "
        [ngClass]="{ active: baseState === 'dashboard' }"
        >
        <img
          class="icon"
          src="/assets/images/home-icon.png"
          alt="Home"
          />Dashboard
          <img
            src="/assets/images/down-arrow.png"
            class="arrow"
            [ngClass]="{ 'arrow-up': isCollapsed.dashboard }"
            />
        </a>
        @if (isCollapsed.dashboard) {
          <ul class="sub-menu">
            @if (userSummary?.status === 'interested_mail_delivered') {
              <li
                class="menu-item"
                [ngClass]="{ active: isActive('dashboard/get-started') }"
                (click)="goToPage('dashboard/get-started')"
                id="nav-menu-getstarted-link"
                >
                Get Started
              </li>
            }
            @if (userSummary?.status !== 'interested_mail_delivered') {
              <li
                class="menu-item"
                [ngClass]="{ active: isActive('dashboard/summary') }"
                (click)="goToPage('dashboard/summary')"
                id="nav-menu-summary-link"
                >
                Summary
              </li>
            }
            @if (showJourneyTV) {
              <li
                class="menu-item"
                [ngClass]="{ active: isActive('dashboard/journeytv') }"
                (click)="goToPage('dashboard/journeytv')"
                id="nav-menu-journeytv-link"
                >
                JourneyTV
              </li>
            }
            <li
              class="menu-item"
              [ngClass]="{ active: isActive('dashboard/referrals') }"
              (click)="goToPage('dashboard/referrals')"
              id="nav-menu-referrals-link"
              >
              Referrals
            </li>
            @if (userSummary?.status !== 'interested_mail_delivered') {
              <li
                class="menu-item"
                [ngClass]="{ active: isActive('dashboard/points') }"
                (click)="goToPage('dashboard/points')"
                id="nav-menu-points-link"
                >
                Points
              </li>
            }
            @if (userSummary?.status !== 'interested_mail_delivered') {
              <li
                class="menu-item"
                [ngClass]="{ active: isActive('dashboard/offers') }"
                (click)="goToPage('dashboard/offers')"
                id="nav-menu-rewards-link"
                >
                Rewards
              </li>
            }
            <li
              class="menu-item"
              [ngClass]="{ active: isActive('dashboard/payments') }"
              (click)="goToPage('dashboard/payments')"
              id="nav-menu-payments-link">
              Payments
            </li>
            @if (
              !userSummary?.flexdrive_status ||
              (userSummary?.flexdrive_status === 'former' &&
              userSummary?.status === 'Active Driver')
              ) {
              <li
                class="menu-item"
                [ngClass]="{ active: isActive('dashboard/account') }"
                (click)="goToPage('dashboard/account')"
                id="nav-menu-accountstatus-link"
                id="nav-menu-dashboard-account-status"
                >
                Account Status
              </li>
            }
          </ul>
        }
      </li>
      <li class="menu-item" [ngClass]="{ selected: isCollapsed.myAccount }" id="nav-menu-my-account">
        @if (userSummary?.status === 'former_driver') {
          <a
            [ngClass]="{ active: baseState === 'my-account' }"
            id="nav-menu-formerdrivermyaccount-link"
            >
            <img
              class="icon"
              src="/assets/images/person-icon.png"
              alt="default-profile"
              />My Account
            </a>
          }
          @if (userSummary?.status !== 'former_driver') {
            <a
              id="nav-menu-myaccount-link"
                (click)="
                    $event.stopPropagation();
                    isCollapsed.myAccount = !isCollapsed.myAccount
                "
              [ngClass]="{ active: baseState === 'my-account' }"
              >
            <img
              class="icon"
              src="/assets/images/person-icon.png"
              alt="default-profile"
              />My Account
              <img
                src="/assets/images/down-arrow.png"
                class="arrow"
                [ngClass]="{ 'arrow-up': isCollapsed.myAccount }"
                />
            </a>
          }
          @if (isCollapsed.myAccount) {
            <ul class="sub-menu">
              @if (
                (userSummary?.status !== 'former_driver' &&
                !userSummary?.flexdrive_status) ||
                (userSummary?.flexdrive_status === 'former' &&
                userSummary?.status === 'Active Driver')
                ) {
                <li
                  class="menu-item"
                  (click)="goToPage('my-account/driver-info')"
                  [ngClass]="{ active: isActive('my-account/driver-info') }"
                  id="nav-menu-myaccount-info-link"
                  >
                  Driver Info
                </li>
              }
              @if (userSummary?.status !== 'former_driver') {
                <li
                  class="menu-item"
                  (click)="goToPage('my-account/agreement')"
                  [ngClass]="{ active: isActive('my-account/agreement') }"
                  id="nav-menu-myaccount-agreement-link"
                  >
                  Agreement
                </li>
              }
              @if (userSummary?.status !== 'former_driver' && !userSummary?.is_partner) {
                <li
                  class="menu-item"
                  (click)="goToPage('my-account/profile')"
                  [ngClass]="{ active: isActive('my-account/profile') }"
                  id="nav-menu-myaccount-profile-link"
                  >
                  Tablet Profile
                </li>
              }
              @if (userSummary?.status !== 'former_driver') {
                <li
                  class="menu-item"
                  (click)="goToPage('my-account/payment-details')"
                    [ngClass]="{
                        active: isActive('my-account/payment-details')
                    }"
                  id="nav-menu-myaccount-payment-link"
                  >
                  Payment Details
                </li>
              }
              @if (userSummary?.payment_info?.w9_status) {
                <li
                  class="menu-item"
                  (click)="goToPage('my-account/w9details')"
                  [ngClass]="{ active: isActive('my-account/w9details') }"
                  id="nav-menu-myaccount-tax-link"
                  >
                  Tax Info Verification
                </li>
              }
            </ul>
          }
        </li>
        <li class="menu-item extra-pad">
          <a href="https://playoctopus.com/help/" target="_blank" id="nav-menu-help-link">
            <img
              class="icon"
              src="/assets/images/chat-icon.png"
              alt="Chat"
              />Help Support
            </a>
          </li>
          @if (!isAdmin) {
            <li class="menu-item">
              <button type="button" (click)="logOut()" id="nav-menu-logout-link">
                <img class="icon" src="/assets/images/log-out-icon.png" alt="Log out" />Log
                Out
              </button>
            </li>
          }
        </ul>
      </nav>
